/* GSW: nach erfolgreichem Hinzufuegen direkt auf /cart (cart_type = page, gsw-cart-weiter:v1).
   Hoert auf das Horizon-Ereignis cart:update. Fehler (didError, z. B. zu wenig Bestand) bleiben
   auf der Seite. Quellen: Produktformular (Produktseite, Kollektions-Schnellkauf) und das
   Zubehoer-Snippet der Produktseite. Express-Buttons (Shop Pay, PayPal) laufen ueber den Checkout
   und sind nicht betroffen. Kurze Verzoegerung, damit das Plattformereignis product_added_to_cart
   seine Messanfrage noch absetzen kann. */
(function () {
  if (window.__gswCartWeiter) return;
  window.__gswCartWeiter = true;
  var QUELLEN = ['product-form-component', 'gsw-zubehoer'];
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (!d || d.didError || QUELLEN.indexOf(d.source) === -1) return;
    if (window.Shopify && Shopify.designMode) return;
    var ziel = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    if (window.location.pathname.replace(/\/$/, '') === ziel) return;
    setTimeout(function () { window.location.assign(ziel); }, 250);
  });
})();
